import React from 'react';
import ProblemDiagnosisComponent from '../components/ProblemDiagnosis';

const ProblemDiagnosis: React.FC = () => {
  return <ProblemDiagnosisComponent />;
};

export default ProblemDiagnosis;
